import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import ObjectManagement from '../components/ObjectManagement';
import AddObjectDialog from '../components/AddObjectDialog';
// ❌ ENTFERNT: MietvertragManagement (alte Version) - nicht mehr verwendet


const Objekte = () => {

  const [dialogOpen, setDialogOpen] = useState(false);

  // Funktion, um das Dialogfenster zu öffnen
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  // Funktion, um das Dialogfenster zu schließen
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  // Funktion zum Speichern der Daten (hier kannst du die Logik zum Speichern in die Datenbank einfügen)
  const handleSave = (formData) => {
    // Füge hier die Logik zum Speichern in die Datenbank hinzu
  };


  return (
    <div>
      <h1>Objekte</h1>
      <p>Willkommen auf dem Objekte!</p>
      <br/>
      <br/>
      <Box my={4}>
        <Button variant="contained" color="primary" onClick={handleOpenDialog}>
          Objekt anlegen
        </Button>

        <AddObjectDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          onSave={handleSave}
        />

        <ObjectManagement/>
      </Box>

      {/* ❌ ENTFERNT: MietvertragManagement Komponente - wird jetzt über /dashboard/mietvertrag bereitgestellt */}
    </div>
  );
};

export default Objekte;